import {Component, inject, OnInit, QueryList, ViewChildren} from '@angular/core';
import {MatExpansionPanel} from "@angular/material/expansion";
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store";
import {Faq} from "../../../store/entities/system-configurations/faq/faq.model";
import {selectStoreItems} from "../../../store/entities/store-item/store-item.selectors";
import {StoreItemEntity} from "../../../store/entities/store-item/store-item.model";
import {StoreItemActions} from "../../../store/entities/store-item/store-item.actions";
import {GET_ALL_FAQS} from "../../../store/entities/system-configurations/faq/faq.graphql";
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-guest-faq',
  templateUrl: './guest-faq.component.html',
  styleUrl: './guest-faq.component.scss'
})
export class GuestFaqComponent implements OnInit {
  translate: TranslateService = inject(TranslateService)
  useEng: boolean;
  openedFaq: number = -1


  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;
  faqs$: Observable<Faq[]>
  store = inject(Store<AppState>)

  changePanelState() {
    let expandedIndex: number = -1
    this.panels.forEach((panel, idx) => {
      if (panel.expanded) {
        expandedIndex = idx
      }
    });

    this.openedFaq = expandedIndex !== -1 ? expandedIndex : -1
  }

  ngOnInit() {
    this.useEng = this.translate.currentLang === 'en';

    this.faqs$ = this.store.select(selectStoreItems(StoreItemEntity.faq));
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      query: GET_ALL_FAQS,
      entity: StoreItemEntity.faq,
      filtering: {},
    }));
  }


}
